import React from 'react';
import ProductFeature from '../ProductFeature';
import commercePropTypes from '../../prop-types/commercePropTypes';

var ProductFeatureList = function ProductFeatureList(_ref) {
  var list = _ref.list,
      alternatePosition = _ref.alternatePosition;
  return list.map(function (item, index) {
    var title = item.title,
        titleColor = item.titleColor,
        subtitle = item.subtitle,
        subtitleColor = item.subtitleColor,
        ctaList = item.ctaList,
        aside = item.aside,
        isFullWidth = item.isFullWidth,
        descriptionColMedia = item.descriptionColMedia,
        assetColMedia = item.assetColMedia,
        alignItems = item.alignItems,
        verticalSpacing = item.verticalSpacing,
        descriptionHorizontalSpacing = item.descriptionHorizontalSpacing,
        asideHorizontalSpacing = item.asideHorizontalSpacing;
    return /*#__PURE__*/React.createElement(ProductFeature, {
      alternatePosition: alternatePosition ? index % 2 !== 0 : false,
      key: index,
      title: title,
      titleColor: titleColor,
      subtitle: subtitle,
      subtitleColor: subtitleColor,
      ctaList: ctaList,
      aside: aside,
      isFullWidth: isFullWidth,
      descriptionColMedia: descriptionColMedia,
      assetColMedia: assetColMedia,
      alignItems: alignItems,
      verticalSpacing: verticalSpacing,
      descriptionHorizontalSpacing: descriptionHorizontalSpacing,
      asideHorizontalSpacing: asideHorizontalSpacing
    });
  });
};

ProductFeatureList.defaultProps = {
  alternatePosition: false
};
export default ProductFeatureList;